@if(isOpen){
<div class="overlay">
    &nbsp;
</div>
<div class="lookup-box-wrapper center-full {{localService.selectedLanguageCode}}">
    <div class="side_popup_header">
        <span>{{selectedLookUpName}}</span>
        <button class="button_icon" (click)="onAction(1)">close</button>
    </div>
    <div class="side_popup_body"
        *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.lookup && localService.languageContent.paging">
        <div *ngIf="lookupType != LookupType.None">
            <div class="row row_header freeze_height">
                <div class="col-3">
                    {{localService.languageContent.lookup.value}}
                </div>
                <div class="col-9">
                    {{localService.languageContent.table.title}}
                </div>
            </div>
            <div class="custom_rows_body" style="height: calc(90vh - 175px);">
                <div class="row" *ngIf="source && source.paging && source.paging.totalCount == 0">
                    <div class="col-12" style="text-align:center;">
                        <div style="margin-top:10%;">
                            {{localService.languageContent.paging.no_records}}
                        </div>
                    </div>
                </div>
                <div *ngIf="(source && source.items.length > 0)" class="item-found">
                    <div class="row styled_row" *ngFor="let item of source.items;index as i">
                        <div class="col-md-3">
                            <span class="en dim">{{source.paging.currentPage == 1 && i < 9 ? '0' : ''
                                    }}{{((source.paging.currentPage - 1) * source.paging.dataPerPage) + (i +
                                    1)}}.</span>
                                    <button (click)="onAction(2,item.v1)"
                                        [ngClass]="item.isSelected ? 'list_option_radio_on button_icon' : 'list_option_radio button_icon-outline'">
                                        {{item.isSelected ? 'check_circle' : 'circle' }}
                                    </button>
                                    <button class="button_icon button_icon_color icon_adjust"
                                        (click)="localService.copyContent(item.v1)">
                                        content_copy
                                    </button>
                                    <span class="en">{{item.v1}}</span>
                        </div>
                        <div class="col-md-9">
                            <span [ngClass]="localService.getLanguageCode(item.v6)">
                                {{item.v5}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row" *ngIf="source && source.paging">
            <div class="col-md-6">
                <input autocomplete="off" type="text" [(ngModel)]="source.paging.searchKey"
                    style="height: 40px;border-color: brown;width: calc(100% - 40px);"
                    title="{{localService.languageContent.paging.search_key}}" id="{{elementIds.search}}"
                    placeholder="{{localService.languageContent.paging.search_key}}" (keydown.enter)="onAction(6)" />
                <button class="button_icon button_icon_color" style="margin: 5px;top: 8px;" (click)="onAction(6)">
                    search
                </button>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6">
                        <span class="en" style="top: 8px; position: relative;">({{((source.paging.currentPage - 1) *
                            source.paging.dataPerPage)+ (source.paging.totalCount > 0 ? 1 :
                            0)}}-{{(source.paging.currentPage *
                            source.paging.dataPerPage) > source.paging.totalCount ? source.paging.totalCount :
                            (source.paging.currentPage *
                            source.paging.dataPerPage)}})/{{source.paging.totalCount}}&nbsp;&nbsp;</span>
                    </div>
                    <div class="col-6" style="text-align: right;">
                        <span class="en">{{source.paging.currentPage}}/{{source.paging.totalPage}}&nbsp;&nbsp;</span>
                        <button class="button_icon-outline" style="top: 5px;" (click)="onAction(3)"
                            [disabled]="source.paging.currentPage <= 1">
                            arrow_circle_left
                        </button>
                        <button class="button_icon-outline" style="top: 5px;" (click)="onAction(4)"
                            [disabled]="source.paging.currentPage == source.paging.totalPage">
                            arrow_circle_right
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}